export const locales = ['en', 'de'];
export const defaultLocale = 'en';

export type Locale = 'en' | 'de';
